import { ILetterGenerationPdf } from '../../models/ILetterGenerationPdf';
import { ILetterMetadata } from '../../models/ILetterMetadata';
import { MetadataActions, MetadataActionTypes } from '../action-types/metadataActionTypes';

export interface ILetterMetadataState {
  isLoading: boolean;
  isLoadingLetterGeneration: boolean;
  isLoadingLetterSubmission: boolean;
  hasError: boolean;
  hasErrorLetterGeneration: boolean;
  hasErrorLetterSubmission: boolean;
  errorMessage: string;
  errorMessageLetterGeneration: string;
  errorMessageLetterSubmission: string;
  letterMetadata: ILetterMetadata;
  letterPdf: ILetterGenerationPdf | null;
  crmActivityId: string;
}

export const letterMetadataInitialState: ILetterMetadataState = {
  letterMetadata: null,
  isLoading: false,
  isLoadingLetterGeneration: false,
  isLoadingLetterSubmission: false,
  hasError: false,
  hasErrorLetterGeneration: false,
  hasErrorLetterSubmission: false,
  errorMessage: null,
  errorMessageLetterGeneration: null,
  errorMessageLetterSubmission: null,
  letterPdf: null,
  crmActivityId: null,
};

export function letterMetadataReducer(
  prev: ILetterMetadataState = letterMetadataInitialState,
  action: MetadataActions
): ILetterMetadataState {
  switch (action.type) {
    case MetadataActionTypes.REQUEST_METADATA: {
      return {
        ...prev,
        isLoading: true,
        hasError: false,
        errorMessage: null,
      };
    }
    case MetadataActionTypes.RECEIVE_METADATA: {
      return {
        ...prev,
        letterMetadata: action.letterMetadata,
        isLoading: false,
        hasError: false,
        errorMessage: null,
      };
    }
    case MetadataActionTypes.REQUEST_METADATA_FAILED: {
      return {
        ...prev,
        letterMetadata: null,
        isLoading: false,
        hasError: true,
        errorMessage: action.errorMessage,
      };
    }
    case MetadataActionTypes.REQUEST_LETTER_GENERATION: {
      return {
        ...prev,
        isLoadingLetterGeneration: true,
        hasErrorLetterGeneration: false,
        errorMessageLetterGeneration: null,
      };
    }
    case MetadataActionTypes.RECEIVE_LETTER_GENERATION: {
      return {
        ...prev,
        letterPdf: action.letterPdf,
        isLoadingLetterGeneration: false,
        hasErrorLetterGeneration: false,
        errorMessageLetterGeneration: null,
      };
    }
    case MetadataActionTypes.REQUEST_LETTER_GENERATION_FAILED: {
      return {
        ...prev,
        letterPdf: null,
        isLoadingLetterGeneration: false,
        hasErrorLetterGeneration: true,
        errorMessageLetterGeneration: action.errorMessage,
      };
    }
    case MetadataActionTypes.REQUEST_LETTER_SUBMISSION: {
      return {
        ...prev,
        isLoadingLetterSubmission: true,
        hasErrorLetterSubmission: false,
        errorMessageLetterSubmission: null,
      };
    }
    case MetadataActionTypes.RECEIVE_LETTER_SUBMISSION: {
      return {
        ...prev,
        crmActivityId: action.crmActivityId,
        isLoadingLetterSubmission: false,
        hasErrorLetterSubmission: false,
        errorMessageLetterSubmission: null,
      };
    }
    case MetadataActionTypes.REQUEST_LETTER_SUBMISSION_FAILED: {
      return {
        ...prev,
        letterPdf: null,
        isLoadingLetterSubmission: false,
        hasErrorLetterSubmission: true,
        errorMessageLetterSubmission: action.errorMessage,
      };
    }
    default:
      return prev;
  }
}
